(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["faq"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", function() {
  const faqItems = document.querySelectorAll("[data-faq]");

  faqItems.forEach(item => {
    const button = item.querySelector(".faq-question");

    button.addEventListener("click", () => {
     
      faqItems.forEach(i => {
        if (i !== item) i.classList.remove("active");
      });

    
      item.classList.toggle("active");
    });
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-account-custom"]) return;
  try {
    

/*document.querySelectorAll('.tab-btn').forEach(btn => {
  btn.addEventListener('click', () => {
    document.querySelectorAll('.tab-btn').forEach(b => b.classList.remove('active'));
    document.querySelectorAll('.tab-content').forEach(c => c.classList.remove('active'));

    btn.classList.add('active');
    document.getElementById(btn.dataset.tab).classList.add('active');
  });
});*/

function renderFavoritesFromLocalStorage() {
  const container = document.getElementById("favorites-grid");
  const emptyMsg = document.getElementById("favorites-empty-msg");


  container.innerHTML = "";


  const data = localStorage.getItem("swym-products");

  if (!data) {
    emptyMsg.style.display = "block";
    return;
  }

  let parsed;
  try {
    parsed = JSON.parse(data);
  } catch (e) {
    console.error("Invalid swym-products data:", e);
    emptyMsg.style.display = "block";
    return;
  }

  const items = parsed.all || [];

  if (!items.length) {
    emptyMsg.style.display = "block";
    return;
  }

  emptyMsg.style.display = "none";


  items.forEach((item) => {
    const productHTML = `
      <div class="product-card">
        <div class="product-card__image">
          <a href="${item.du}">
            <div class="product-card__media">
              <img src="${item.iu}" alt="${item.dt}" class="product-card__img"/>
            </div>
          </a>
        </div>

        <div class="product-card__info">
          <h3 class="product-card__title">${item.dt}</h3>
          <p class="product-card__subtitle">${item.vi || ""}</p>
          <div class="product-card__price">$${item.pr.toFixed(2)}</div>

          <form method="post" action="/cart/add" class="product-card__form">
            <input type="hidden" name="id" value="${item.epi}">
            <button type="submit" class="order-again-btn">{{ 'sections.main_account_custom.add_to_cart' | t }}</button>
          </form>
        </div>
      </div>
    `;

    container.insertAdjacentHTML("beforeend", productHTML);
  });
}


document.querySelectorAll(".tab-btn").forEach((btn) => {
  btn.addEventListener("click", () => {
    document.querySelectorAll(".tab-btn").forEach((b) => b.classList.remove("active"));
    document.querySelectorAll(".tab-content").forEach((c) => c.classList.remove("active"));

    btn.classList.add("active");
    document.getElementById(btn.dataset.tab).classList.add("active");

    if (btn.dataset.tab === "favorites") {
      renderFavoritesFromLocalStorage();
    }
  });
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-testimonials"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", function () {
  const swiperTestimonials = new Swiper(".swiper.testimonials", {
    slidesPerView: 1,
    centeredSlides: true,
    loop: true,
    loopedSlides: 10, 
    spaceBetween: 16,
    speed: 400,
    roundLengths: true,
    observer: true,
    observeParents: true,
    resizeObserver: true,
    mousewheel: { forceToAxis: true },
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
      renderBullet: function (index, className) {
        return `<span class="${className}"><span></span></span>`;
      },
    },
    breakpoints: {
      1024: {
        slidesPerView: 3,
        centeredSlides: true,
        spaceBetween: 16,
      },
    },
    on: {
      init() {
    
        setTimeout(() => {
          this.slideToLoop(0, 0, false);
          this.updateSlides();
          this.updateProgress();
          this.updateSlidesClasses();
          this.updateActiveIndex();
        }, 100);
      },
      resize() {
        setTimeout(() => {
          this.update();
          this.slideToLoop(this.realIndex || 0, 0, false);
        }, 150);
      },
      slideChangeTransitionEnd() {
  
        if (window.innerWidth < 1024) {
          this.slideToLoop(this.realIndex, 0, false);
        }
      },
    },
  });
});





  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["user-image-slider"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", function() {
  // Swiper init
  new Swiper(".user-image-slider", {
    slidesPerView: 1.2,
    spaceBetween: 10,
    loop: true,
    mousewheel: { forceToAxis: true },
    breakpoints: {
      768: {
        slidesPerView: 4,
        spaceBetween: 20
      }
    }
  });

  // Toggle tooltips
  document.querySelectorAll(".marker-btn").forEach(btn => {
    btn.addEventListener("click", () => {
      const id = btn.dataset.product;
      const tooltip = document.getElementById("tooltip-" + id);
      tooltip.classList.toggle("active");
    });
  });

  // Close tooltips
  document.querySelectorAll(".close-tooltip").forEach(close => {
    close.addEventListener("click", (e) => {
      e.target.closest(".product-tooltip").classList.remove("active");
    });
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video-slideshow"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function () {


  // Existing Swiper initialization
  const swiperHoWillUMixIt = new Swiper('.swiper.howillumixit', {
    slidesPerView: 4,
    spaceBetween:0,
    breakpoints: {
      1024: {
        slidesPerView: 4,
        spaceBetween:0,
        centeredSlides: true
      }
    },
    mousewheel: {
      forceToAxis: true,
    },
    centeredSlides: false,
    loop: true,
    speed: 400,
     slideToClickedSlide: false,    
  allowTouchMove: true,          
  });

  window.addEventListener('resize', () => {
    swiperHoWillUMixIt.update();
  });

  document.querySelectorAll('.video-slideshow').forEach(slide => {
  const playBtn = slide.querySelector('button');
  const img = slide.querySelector('img');
  const video = slide.querySelector('.js-slide-video');

  if (video && playBtn) {
    playBtn.addEventListener('click', function() {
      //img.style.display = 'none';
      playBtn.style.display = 'none';
      video.classList.remove('hidden');
      video.muted = true;
      video.play();

  
    });
  }
});

  document.querySelectorAll('.video-slideshow').forEach(slide => {
  const video = slide.querySelector('.js-slide-video');
  if (video) {

    ['mousedown', 'touchstart', 'click', 'focus'].forEach(eventName => {
      video.addEventListener(eventName, e => {
        console.log("video played!");
         swiperHoWillUMixIt.allowSlideNext = false;
        swiperHoWillUMixIt.allowSlidePrev = false;
        
        setTimeout(() => {
          swiperHoWillUMixIt.allowSlideNext = true;
          swiperHoWillUMixIt.allowSlidePrev = true;
        }, 2000);
      });
    });
  }
});



});

  } catch(e) { console.error(e); }
})();
})();
